export enum CheckboxSize {
  small = "small",
  large = "large",
}
